/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Generating_Secure_LinkInputs */

const en_generating_secure_link = /** @type {(inputs: Generating_Secure_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating secure link...`)
};

const es_generating_secure_link = /** @type {(inputs: Generating_Secure_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando enlace seguro...`)
};

const fr_generating_secure_link = /** @type {(inputs: Generating_Secure_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génération du lien sécurisé...`)
};

const de_generating_secure_link = /** @type {(inputs: Generating_Secure_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherer Link wird generiert...`)
};

const ja_generating_secure_link = /** @type {(inputs: Generating_Secure_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全なリンクを生成中...`)
};

const zh_generating_secure_link = /** @type {(inputs: Generating_Secure_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在生成安全链接...`)
};

const ar_generating_secure_link = /** @type {(inputs: Generating_Secure_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري إنشاء رابط آمن...`)
};

const id_generating_secure_link = /** @type {(inputs: Generating_Secure_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menghasilkan tautan aman...`)
};

const it_generating_secure_link = /** @type {(inputs: Generating_Secure_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione link sicuro...`)
};

const ru_generating_secure_link = /** @type {(inputs: Generating_Secure_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создание безопасной ссылки...`)
};

const pt_generating_secure_link = /** @type {(inputs: Generating_Secure_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerando link seguro...`)
};

const ko_generating_secure_link = /** @type {(inputs: Generating_Secure_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`안전한 링크를 생성하는 중...`)
};

/**
* | output |
* | --- |
* | "Generating secure link..." |
*
* @param {Generating_Secure_LinkInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const generating_secure_link = /** @type {((inputs?: Generating_Secure_LinkInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Generating_Secure_LinkInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_generating_secure_link(inputs)
	if (locale === "es") return es_generating_secure_link(inputs)
	if (locale === "fr") return fr_generating_secure_link(inputs)
	if (locale === "de") return de_generating_secure_link(inputs)
	if (locale === "ja") return ja_generating_secure_link(inputs)
	if (locale === "zh") return zh_generating_secure_link(inputs)
	if (locale === "ar") return ar_generating_secure_link(inputs)
	if (locale === "id") return id_generating_secure_link(inputs)
	if (locale === "it") return it_generating_secure_link(inputs)
	if (locale === "ru") return ru_generating_secure_link(inputs)
	if (locale === "pt") return pt_generating_secure_link(inputs)
	return ko_generating_secure_link(inputs)
});